import UserDetail from 'src/components/Organization/pages/users/detail';

export default UserDetail;
